import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { AppContext } from 'components/Home';

import tf7Logo from '../assets/logo_TF7_white.png';

const Footer = () => {
    const { setPage } = useContext(AppContext);
    const year = new Date().getFullYear();

    return (
        <>
            <Container>
                <ContainerInner>
                    <Link to="/" onClick={() => setPage(0)}>
                        <FooterLogo
                            src={tf7Logo}
                            alt="TwentyFour 7 logo image"
                        />
                    </Link>
                    <ContactInfo>
                        <a href="mailto:inquire@twentyfour7.com">
                            INQUIRE@TWENTYFOUR7.COM
                        </a>{' '}
                        <br />
                        <a
                            href="https://goo.gl/maps/CV2M1iALVfu"
                            target="_blank"
                            className="reverseLinkColor"
                            rel="noreferrer"
                        >
                            425 NE 9TH AVE PORTLAND, OR 97232
                        </a>{' '}
                        <br />
                        <a href="tel:5032227999" className="reverseLinkColor">
                            503.222.7999
                        </a>{' '}
                        <br />
                        <a
                            href="https://staging.twentyfour7.com/wp-content/uploads/TF7_MEDIA-KIT_current.pdf"
                            target="_blank"
                            rel="noreferrer"
                        >
                            DOWNLOAD MEDIA KIT
                        </a>
                        <SocialIcons>
                            <SocialIcon
                                href="https://www.linkedin.com/company/tf7design"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="LinkedIn"
                            >
                                <svg viewBox="0 0 512 512">
                                    <path d="M186.4 142.4c0 19-15.3 34.5-34.2 34.5 -18.9 0-34.2-15.4-34.2-34.5 0-19 15.3-34.5 34.2-34.5C171.1 107.9 186.4 123.4 186.4 142.4zM181.4 201.3h-57.8V388.1h57.8V201.3zM273.8 201.3h-55.4V388.1h55.4c0 0 0-69.3 0-98 0-26.3 12.1-41.9 35.2-41.9 21.3 0 31.5 15 31.5 41.9 0 26.9 0 98 0 98h57.5c0 0 0-68.2 0-118.3 0-50-28.3-74.2-68-74.2 -39.6 0-56.3 30.9-56.3 30.9v-25.2H273.8z"></path>
                                </svg>
                            </SocialIcon>
                            <SocialIcon
                                href="https://www.instagram.com/tf7design/"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Instagram"
                            >
                                <svg viewBox="0 0 512 512">
                                    <path d="M256 109.3c47.8 0 53.4 0.2 72.3 1 17.4 0.8 26.9 3.7 33.2 6.2 8.4 3.2 14.3 7.1 20.6 13.4 6.3 6.3 10.1 12.2 13.4 20.6 2.5 6.3 5.4 15.8 6.2 33.2 0.9 18.9 1 24.5 1 72.3s-0.2 53.4-1 72.3c-0.8 17.4-3.7 26.9-6.2 33.2 -3.2 8.4-7.1 14.3-13.4 20.6 -6.3 6.3-12.2 10.1-20.6 13.4 -6.3 2.5-15.8 5.4-33.2 6.2 -18.9 0.9-24.5 1-72.3 1s-53.4-0.2-72.3-1c-17.4-0.8-26.9-3.7-33.2-6.2 -8.4-3.2-14.3-7.1-20.6-13.4 -6.3-6.3-10.1-12.2-13.4-20.6 -2.5-6.3-5.4-15.8-6.2-33.2 -0.9-18.9-1-24.5-1-72.3s0.2-53.4 1-72.3c0.8-17.4 3.7-26.9 6.2-33.2 3.2-8.4 7.1-14.3 13.4-20.6 6.3-6.3 12.2-10.1 20.6-13.4 6.3-2.5 15.8-5.4 33.2-6.2C202.6 109.5 208.2 109.3 256 109.3M256 77.1c-48.6 0-54.7 0.2-73.8 1.1 -19 0.9-32.1 3.9-43.4 8.3 -11.8 4.6-21.7 10.7-31.7 20.6 -9.9 9.9-16.1 19.9-20.6 31.7 -4.4 11.4-7.4 24.4-8.3 43.4 -0.9 19.1-1.1 25.2-1.1 73.8 0 48.6 0.2 54.7 1.1 73.8 0.9 19 3.9 32.1 8.3 43.4 4.6 11.8 10.7 21.7 20.6 31.7 9.9 9.9 19.9 16.1 31.7 20.6 11.4 4.4 24.4 7.4 43.4 8.3 19.1 0.9 25.2 1.1 73.8 1.1s54.7-0.2 73.8-1.1c19-0.9 32.1-3.9 43.4-8.3 11.8-4.6 21.7-10.7 31.7-20.6 9.9-9.9 16.1-19.9 20.6-31.7 4.4-11.4 7.4-24.4 8.3-43.4 0.9-19.1 1.1-25.2 1.1-73.8s-0.2-54.7-1.1-73.8c-0.9-19-3.9-32.1-8.3-43.4 -4.6-11.8-10.7-21.7-20.6-31.7 -9.9-9.9-19.9-16.1-31.7-20.6 -11.4-4.4-24.4-7.4-43.4-8.3C310.7 77.3 304.6 77.1 256 77.1L256 77.1z"></path>
                                    <path d="M256 164.1c-50.7 0-91.9 41.1-91.9 91.9s41.1 91.9 91.9 91.9 91.9-41.1 91.9-91.9S306.7 164.1 256 164.1zM256 315.6c-32.9 0-59.6-26.7-59.6-59.6s26.7-59.6 59.6-59.6 59.6 26.7 59.6 59.6S288.9 315.6 256 315.6z"></path>
                                    <circle
                                        cx="351.5"
                                        cy="160.5"
                                        r="21.5"
                                    ></circle>
                                </svg>
                            </SocialIcon>
                            <SocialIcon
                                href="https://twitter.com/tf7design"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Twitter"
                            >
                                <svg viewBox="0 0 512 512">
                                    <path d="M419.6 168.6c-11.7 5.2-24.2 8.7-37.4 10.2 13.4-8.1 23.8-20.8 28.6-36 -12.6 7.5-26.5 12.9-41.3 15.8 -11.9-12.6-28.8-20.6-47.5-20.6 -42 0-72.9 39.2-63.4 79.9 -54.1-2.7-102.1-28.6-134.2-68 -17 29.2-8.8 67.5 20.1 86.9 -10.7-0.3-20.7-3.3-29.5-8.1 -0.7 30.2 20.9 58.4 52.2 64.6 -9.2 2.5-19.2 3.1-29.4 1.1 8.3 25.9 32.3 44.7 60.8 45.2 -27.4 21.4-61.8 31-96.4 27 28.8 18.5 63 29.2 99.8 29.2 120.8 0 189.1-102.1 185-193.6C399.9 193.1 410.9 181.7 419.6 168.6z"></path>
                                </svg>
                            </SocialIcon>
                        </SocialIcons>
                    </ContactInfo>
                </ContainerInner>
            </Container>
            <CopyRight>©{year} Twenty Four 7</CopyRight>
        </>
    );
};

export default Footer;

const Container = styled.div`
    padding: 32px 14px 0;
    color: white;
    background: black;
    display: flex;
    flex-direction: row;
    border: 1px solid black;
    align-content: center;
    align-items: flex-start;

    @media (min-width: 1200px) {
        padding: 32px 24px 0;
    }
`;
const ContainerInner = styled.div`
    display: flex;
    max-width: var(--xlarge);
    margin: 0 auto;
    width: 100%;
`;
const FooterLogo = styled.img`
    max-width: 125px;
    width: 35vw;
    z-index: 2;

    @media (min-width: 768px) {
        max-width: 200px;
    }
`;

const ContactInfo = styled.div`
    text-align: right;
    text-transform: uppercase;
    font-family: var(--font-family-medium-condensed);
    line-height: 1.75;
    font-size: 1.25rem;
    margin-left: auto;

    span {
        color: var(--primary);
    }
`;
const SocialIcons = styled.div``;
const SocialIcon = styled.a`
    fill: white;

    svg {
        height: 44px;
        width: 44px;
    }

    :hover {
        fill: var(--primary);
    }
`;
const CopyRight = styled.p`
    clear: both;
    text-align: left;
    color: #444;
    text-transform: uppercase;
    text-align: center;
    font-family: var(--font-family-medium-condensed);
    font-size: 1rem;
    background: black;
    margin: -1px 0 0 0;
    border: 1px solid black;
    padding-bottom: 32px;
`;
